import { render, staticRenderFns } from "./CommunityEventsListWidget.vue?vue&type=template&id=893a439e&scoped=true"
import script from "./CommunityEventsListWidget.vue?vue&type=script&lang=js"
export * from "./CommunityEventsListWidget.vue?vue&type=script&lang=js"
import style0 from "./CommunityEventsListWidget.vue?vue&type=style&index=0&id=893a439e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893a439e",
  null
  
)

export default component.exports